import React, { useState, useEffect } from "react";

// this component include label, input text box
// required *, help/tip message, and error state with error message

// base on input props.isRequired, props.hasError
// update the className, to show error, and required

// use props.value to set text
// use on chagne props.getTextString return new value to parent

const InputTxt = (props) => {
  const [maxChar, setMaxChar] = useState(
    props.maxLength ? props.maxLength : -1
  );

  // can preset text or set string to empty
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputType, setInputType] = useState(props.type || "text");

  // if user paste string or enter last char is 3 bytes
  // remove last char until it fit
  function removeExtra(strASCII) {
    var newStrASCII = strASCII;
    let strUTF8 = 0;
    do {
      newStrASCII = newStrASCII.substring(0, newStrASCII.length - 1);
      strUTF8 = new TextEncoder("utf-8").encode(newStrASCII);
    } while (strUTF8.length >= props.maxLength);

    return newStrASCII;
  }

  // update the maxLength onChange
  function updateMaxLength(strASCII) {
    let strUTF8 = new TextEncoder("utf-8").encode(strASCII);

    // if user paste string, check the length, and remove until fit
    if (strUTF8.length > props.maxLength) {
      //console.log("too long, strUTF8.length = ", strUTF8.length);
      let newStrASCII = removeExtra(strASCII);
      setInputValue(newStrASCII);
      strASCII = newStrASCII;
      strUTF8 = new TextEncoder("utf-8").encode(newStrASCII);
    } else {
      setInputValue(strASCII);
    }

    //console.log("strASCII.length = ", strASCII.length);
    //console.log("strUTF8.length = ", strUTF8.length);
    //console.log("strUTF8 = -" + strUTF8 + "-");
    //console.log("maxChar = ", maxChar);

    // check the utf8 length, if too long, change the max length to match
    if (strUTF8.length > strASCII.length) {
      setMaxChar(
        (preMaxChar) => props.maxLength - (strUTF8.length - strASCII.length)
      );
      //console.log("new maxChar = ", maxChar);
    } else {
      setMaxChar((preMaxChar) => props.maxLength);
      //console.log("reset maxChar = ", maxChar);
    }

    return strASCII;
  }

  // default onChange handler
  function defaultOnChange(e) {
    // only check maxLength if type is text and maxLength is set
    // other type like password should not check
    //console.log("on change e", e, e.target.value);
    let newString = e.target.value;
    if (props.type === "text") {
      newString = updateMaxLength(e.target.value);
    } else {
      newString = e.target.value;
      setInputValue(e.target.value);
    }

    //console.log("e password", e);
    // onChange is return value to formik
    if (props.onChange !== undefined && props.onChange !== null) {
      props.onChange(e);
    } //else {
    //}

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {
      props.getTextString(newString);
    } //else {
    //}
  }
  function defaultOnBlur(e) {
    //console.log("onblur e ", e.target.value);
    let newString = e.target.value;
    if (props.type === "text") {
      newString = updateMaxLength(e.target.value);
    } else {
      newString = e.target.value;
      setInputValue(e.target.value);
    }

    //console.log("e password", e);
    // onChange is return value to formik
    if (props.onBlur !== undefined && props.onBlur !== null) {
      props.onBlur(e);
    }

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {
      props.getTextString(newString);
    }
  }

  function hideshowPassword() {
    if (inputType === "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  }
  
  	// on page load, update text value
	useEffect(() => {
    		setInputValue(props.value || "");
	},[props.value]);

  return (
    <div className="inputbox">
      {/* display label */}
      <label
        className={`inputbox__label ${
          props.hasError ? "inputbox__label--error" : ""
        }
        ${props.isDisabled ? "inputbox__label--disabled" : ""}
        `}
      >
        {props.labelText}
        {/* display reqiored * */}
        <span
          className="inputbox__required"
          style={props.isRequired ? {} : { display: "none" }}
        >
          *
        </span>
        {/* text input box */}
        <div>
          <input
            id={props.id}
            type={inputType}
            required={props.isRequired ? true : false}
            placeholder={props.placeholder}
            className={`inputbox__textbox ${
              props.hasError ? "inputbox__textbox--error" : ""
            }`}
            value={inputValue}
            maxLength={maxChar ? maxChar : -1}
            onChange={(e) => defaultOnChange(e)}
            onBlur={(e) => defaultOnBlur(e)}
            disabled={props.isDisabled ? true : false}
            inputMode={props.inputMode ? props.inputMode : "text"}
          />
          <span
            class="inputbox__hideshow-controller"
            style={
              props.type === "password" && inputType === "password"
                ? {}
                : { display: "none" }
            }
            onClick={(e) => hideshowPassword()}
          >
            Show
          </span>
          <span
            class="inputbox__hideshow-controller"
            style={
              props.type === "password" && inputType === "text"
                ? {}
                : { display: "none" }
            }
            onClick={(e) => hideshowPassword()}
          >
            Hide
          </span>
        </div>
        <div className="phoneinput__container">
          {" "}
          {/* force display grid */}
          {/* display help message */}
          <span className="inputbox__help">{props.helpMessage}</span>
          {/* display errorMessage or formik error message */}
          <span
            className="inputbox__error"
            style={props.hasError ? {} : { display: "none" }}
          >
            {props.errorMessage}
          </span>
        </div>
      </label>
    </div>
  );
};

export default InputTxt;
